import { render, staticRenderFns } from "./NotaVideoLayoutDesktop.vue?vue&type=template&id=66cae1a9&scoped=true&"
import script from "./NotaVideoLayoutDesktop.vue?vue&type=script&lang=js&"
export * from "./NotaVideoLayoutDesktop.vue?vue&type=script&lang=js&"
import style0 from "./NotaVideoLayoutDesktop.vue?vue&type=style&index=0&id=66cae1a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cae1a9",
  null
  
)

export default component.exports